module.exports = __webpack_public_path__ + "img/hr-sand-decal-13.9a232c58.png";